import {
  axiosConfig,
  del,
  get,
  patch,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  EmploymentInquiryPayload,
  EmploymentInquiryRecord,
} from "@project/types/gruh-udhyog";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/employment-inquiries`;
const SILENT: RequestConfig = { showNotification: false };

class EmploymentInquiryService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<EmploymentInquiryRecord>> => {
    return fetchListPage<EmploymentInquiryRecord>(`${BASE}/`, query);
  };

  get = async (
    id: number
  ): Promise<EmploymentInquiryRecord | undefined> => {
    const data = await get<
      ApiItemResponse<EmploymentInquiryRecord> | EmploymentInquiryRecord
    >(`${BASE}/${id}/`, SILENT_LIST);
    return unwrapItem(data);
  };

  create = async (payload: EmploymentInquiryPayload): Promise<EmploymentInquiryRecord> => {
    const response = await axiosConfig.post<
      ApiItemResponse<EmploymentInquiryRecord> | EmploymentInquiryRecord
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(response.data);
    if (!item) {
      return response.data as EmploymentInquiryRecord;
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<EmploymentInquiryPayload>
  ): Promise<EmploymentInquiryRecord | undefined> => {
    const data = await patch<
      ApiItemResponse<EmploymentInquiryRecord> | EmploymentInquiryRecord,
      Partial<EmploymentInquiryPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const employmentInquiryService = new EmploymentInquiryService();
